import React, { useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import "./PrincipiosRectores.css";

/**
 * Principios Rectores del Instituto Tlaxcalteca de Elecciones (ITE)
 * Rediseño tipo infografía formal y sobrio con tarjetas, preservando íntegramente
 * todos los textos originales palabra por palabra.
 */

const getPrincipioIcon = (name) => {
  switch (name) {
    case "Constitucionalidad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
          <path d="M8 7h8" />
          <path d="M8 11h5" />
          <circle cx="15" cy="14" r="2.5" />
          <path d="M15 16.5v4l1.5-1 1.5 1v-4" />
        </svg>
      );
    case "Legalidad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 3v18" />
          <path d="M5 7h14" />
          <path d="m2 14 3-7 3 7a3 3 0 0 1-6 0Z" />
          <path d="m16 14 3-7 3 7a3 3 0 0 1-6 0Z" />
          <path d="M8 21h8" />
        </svg>
      );
    case "Certeza":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case "Autonomía":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 9.9-1" />
          <circle cx="12" cy="16" r="1.5" />
          <path d="M12 17.5v2" />
        </svg>
      );
    case "Independencia":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
          <path d="M12 7v10" />
          <path d="M8 11h8" />
        </svg>
      );
    case "Imparcialidad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 2v20" />
          <path d="M4 6h16" />
          <circle cx="12" cy="6" r="1.5" />
          <path d="m2 13 2-7 2 7a2 2 0 0 1-4 0Z" />
          <path d="m18 13 2-7 2 7a2 2 0 0 1-4 0Z" />
          <path d="M7 22h10" />
        </svg>
      );
    case "Equidad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M7 9.5h10" />
          <path d="M7 14.5h10" />
        </svg>
      );
    case "Objetividad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1.5" />
          <path d="M12 2v3" />
          <path d="M12 19v3" />
          <path d="M2 12h3" />
          <path d="M19 12h3" />
        </svg>
      );
    case "Profesionalismo":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="8.5" r="5.5" />
          <circle cx="12" cy="8.5" r="2" />
          <path d="m15.5 13.5 2.5 7.5-6-3.5-6 3.5 2.5-7.5" />
        </svg>
      );
    case "Máxima Publicidad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m3 11 14-5v12L3 13v-2Z" />
          <path d="M11.5 16.5a2.5 2.5 0 0 1-5 1" />
          <path d="M18 9c1.2.9 2 2.1 2 3.5s-.8 2.6-2 3.5" />
          <path d="M20.5 6.5C22.2 8.1 23 10 23 12.5s-.8 4.4-2.5 6" />
        </svg>
      );
    case "Paridad":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="9" cy="8.5" r="4.5" />
          <path d="M9 13v8" />
          <path d="M6 17h6" />
          <circle cx="16" cy="15" r="3.5" />
          <path d="m18.5 12.5 2.5-2.5" />
          <path d="M18.5 10h2.5v2.5" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
  }
};

const PRINCIPIOS_DATA = [
  {
    name: "Constitucionalidad",
    text: "Referido al apego escrupuloso que mantiene el Instituto en el mandato constitucional para el ejercicio de sus atribuciones y el desempeño de las funciones encomendadas.",
  },
  {
    name: "Legalidad",
    text: "El Instituto Tlaxcalteca de Elecciones debe observar escrupulosamente el mandato constitucional en el ejercicio de las atribuciones y el desempeño de las funciones que tiene encomendadas, así como las disposiciones legales que lo reglamentan.",
  },
  {
    name: "Certeza",
    text: "Todas las acciones que desempeñe el Instituto Tlaxcalteca de Elecciones estarán dotadas de veracidad, certidumbre y apego a los hechos, esto es, que los resultados de sus actividades sean completamente verificables, fidedignos y confiables.",
  },
  {
    name: "Autonomía",
    text: "Se establece como la facultad que le otorga la ley al Instituto Tlaxcalteca de Elecciones, que le permite actuar, hacer o decidir en la deliberación de sus procesos y desarrollo de sus actividades en apego a las normas y leyes que lo reglamentan.",
  },
  {
    name: "Independencia",
    text: "Es la garantía que disponen las autoridades que conforman la Institución para que sus procesos de deliberación y toma de decisiones se den con absoluta libertad y respondan única y exclusivamente al imperio de la ley.Es la garantía que disponen las autoridades que conforman la Institución para que sus procesos de deliberación y toma de decisiones se den con absoluta libertad y respondan única y exclusivamente al imperio de la ley.",
  },
  {
    name: "Imparcialidad",
    text: "En el desarrollo de sus actividades, el Instituto Tlaxcalteca de Elecciones debe reconocer y velar permanentemente por el interés de la sociedad y por los valores fundamentales de la democracia, supeditando a éstos, de manera irrestricta, cualquier interés personal o preferencia política.",
  },
  {
    name: "Equidad",
    text: "Es considerada como un instrumento del derecho que permite la aplicación de las disposiciones legales a casos concretos, en un estricto sentido de justicia e imparcialidad.",
  },
  {
    name: "Objetividad",
    text: "La objetividad implica al Instituto Tlaxcalteca de Elecciones un quehacer institucional fundado en el reconocimiento coherente y razonado de la realidad sobre la que se actúa y la obligación de percibir e interpretar los hechos por encima de visiones y opiniones, parciales o unilaterales, máxime si éstas pueden alterar la expresión o consecuencia del quehacer del Instituto.",
  },
  {
    name: "Profesionalismo",
    text: "Se establece como una condición que mantiene el Instituto Tlaxcalteca de elecciones en el desarrollo de sus actividades en base a la eficacia, aplicación, seriedad, honradez y pericia.",
  },
  {
    name: "Máxima Publicidad",
    text: "Todos los actos y la información en poder del Instituto Tlaxcalteca de Elecciones son públicos y sólo por excepción se podrán reservar en los casos expresamente previstos por las leyes y justificados bajo determinadas circunstancias.",
  },
  {
    name: "Paridad",
    text: "La paridad es un principio constitucional que tiene como finalidad la igualdad sustantiva entre los sexos, que adopta nuestro país como parte de los compromisos internacionales que ha adquirido con el objeto de que los derechos político electorales de las y los ciudadanos se ejerzan en condiciones de igualdad.",
  },
];

const PrincipiosRectores = () => {
  useEffect(() => {
    document.title = "Principios Rectores";
  }, []);

  return (
    <>
      <TitlePages title="Principios Rectores" subTitle="" />

      <article className="principles-page" lang="es">
        <header className="principles-intro">
          <div className="principles-intro__grid">
            <div className="principles-intro__card">
              <p>
                La Constitución Política del Estado de Tlaxcala en su artículo 95 señala
                que el Instituto Tlaxcalteca de Elecciones, cumplirá sus funciones bajo
                los principios de constitucionalidad, legalidad, imparcialidad,
                objetividad, equidad, certeza, profesionalismo, independencia y máxima
                publicidad.
              </p>
            </div>
            <div className="principles-intro__card">
              <p>
                De la misma manera, el artículo 2 de la Ley de Instituciones y
                Procedimientos para el Estado de Tlaxcala establece como principios
                rectores en el ejercicio de la función electoral, la constitucionalidad,
                legalidad, certeza, autonomía, independencia, imparcialidad, equidad,
                objetividad, profesionalismo y máxima publicidad
              </p>
            </div>
          </div>
        </header>

        <ol className="principles">
          {PRINCIPIOS_DATA.map((principio, index) => (
            <li
              key={principio.name}
              className="principles__item"
              tabIndex={0}
            >
              <div className="principles__header">
                <div className="principles__icon-wrap">
                  {getPrincipioIcon(principio.name)}
                </div>
                <span className="principles__num" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="principles__name">{principio.name}</h3>
              <div className="principles__divider" aria-hidden="true" />
              <p className="principles__text">{principio.text}</p>
            </li>
          ))}
        </ol>
      </article>
    </>
  );
};

export default PrincipiosRectores;
